import React, { useState } from "react";
import TitleName from "../../components/ui/TitleNameSec/TitleName";
import Links from "../../components/ui/Links/Links";
import Discription from "../../components/ui/Discription/Discription";

import { AnimatePresence, motion } from "motion/react";
import { useEffect, useRef, useCallback } from "react";

const HomePage = () => {
  const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  const [theme, setTheme] = useState(prefersDark ? "dark-mode" : "light-mode");

  // Listen for system theme changes
  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const handleChange = (e) => {
      setTheme(e.matches ? "dark-mode" : "light-mode");
    };
    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  // Apply theme to body
  useEffect(() => {
    document.body.classList.remove("light-mode", "dark-mode");
    document.body.classList.add(theme);
  }, [theme]);

  // Manual toggle
  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark-mode" ? "light-mode" : "dark-mode"));
  };

  const projectsWorthNoting = [
    {
      priority: 0,
      name: "Lumeku CRM",
      description:
        "From lead capture to deal closure, manage your entire sales process with tools for lead management, deal tracking, email integration, and comprehensive reporting.",
      url: "https://lumeku.com/",
      tags: ["CRM"],
      technology: ["Laravel", "React", "SQL", ""],
      state: "Prod",
    },
    {
      priority: 1,
      name: "Lusuno",
      description:
        "From application to repayment tracking, manage your entire lending workflow with tools designed for efficiency, compliance, and control.",
      url: "https://lusuno.com/",
      tags: ["Loan Management system", "fincial"],
      technology: ["Node", "React", "SWR", "Redis", "Postgres"],
      state: "Prod",
    },
  ];
  const workExpirince = [
    {
      companyName: "Afrimeta Technologies",
      companyRole: "Senior Software Engineer & UI/UX",
      startDate: "Sep 2023",
      endDate: "Present",
      companyUrl: "http://afrimetatechnologies.com/",
      locationWorkType: "Lusaka, Zambia · (On-Site)",
      achievements: [
        "Lead Multiple projects in developing new features, sprint planning and testing.",
        "Integrated multiple payment gateways.",
        "Integrated Yango, a third-party logistics service, into the platform.",
        "Integrated Error logging system with real-time notifications and Severity Levels.",
        "Generated Dynamic Sitemaps to improve SEO rankings and show updated products.",
      ],
      projects: [
        {
          name: "b2b Traderr",
          description:
            " A b2b trading platform that connects buyers and sellers.",
          url: "https://b2btraderr.com/",
          tags: ["ecommerce", "b2b", "AWS", "INGIX"],
        },
      ],
    },
    {
      companyName: "Imuks App solution",
      companyRole: "Software Engineer & UI/UX",
      startDate: "Sep 2021",
      endDate: "Sep 2023",
      companyUrl: "https://www.facebook.com/imuksAppSolutions/",
      locationWorkType: "Lusaka, Zambia · (Hybrid)",

      achievements: [
        "Built enterprise systems that scale using Ant Design, AWS, Next.js and more.",
        "Lead Mobile Developer for Zambia Energy Efficiency App (IOS & Android).",
        "Lead Frontend Developer for a Record Management system for enterprise-level organisations.",
      ],
      projects: [
        {
          name: "Paperless",
          description:
            "Record management system for enterprise-level organisations.",
          url: "https://paperless.imuks.com/",
          tags: ["Next.js", "React", "Ant Design", ""],
        },
        {
          name: "Zambia Energy Efficiency App (IOS & Android).",
          description:
            "The energy meter enables you to record your energy meter readings and track your consumption over time. The energy meter allows you to benchmark your consumption with other users within and across sectors. It allows you to view your consumption in graphical mode daily, weekly, monthly, and quarterly with an additional feature to download your consumption data for further analysis of choice.",
          url: "https://zambia-energy-efficiency-app.appstor.io/",
          tags: ["React Native"],
        },
      ],
    },
    {
      companyName: "WorksHub",
      companyRole: "Frontend Developer",
      startDate: "Apr 2022",
      endDate: "Aug 2022",
      companyUrl: "https://www.works-hub.com/",
      locationWorkType: "London, UK · (Remote)",
      achievements: [
        "Helped the team move from Clojure to React and Next.js Frontend.",
      ],
    },
    {
      companyName: "Hackers Guild",
      companyRole: "Software Engineer",
      startDate: "Feb 2020",
      endDate: "Apr 2022",
      companyUrl: "https://zm.linkedin.com/company/hackers-guild",
      locationWorkType: "Lusaka, Zambia · (Hybrid)",
      achievements: [
        "Provided ongoing maintenance, support and enhancements on existing systems.",
        "Worked alongside engineers to elevate technology and apply best practices.",
        "Replicated designs to pixel-perfect implementation.",
        "Created, improved and prototyped UI Designs.",
        "Bootcamp trainer.",
      ],
      projects: [],
    },
    {
      companyName: "Kati Mamulio Institute of IT",
      companyRole: "Computer Technician",
      startDate: "Dec 2017",
      endDate: "Dec 2019",
      companyUrl: "#",
      locationWorkType: "Lusaka, Zambia · (On-Site)",
      achievements: [
        "Maintained computer systems within a business setting.",
        "Installed computers, routers and other hardware.",
        "Updated or repaired existing systems and troubleshot hardware problems.",
      ],
    },
  ];

  const WorkExperienceCard = ({
    companyName,
    companyRole,
    startDate,
    endDate,
    companyUrl,
    locationWorkType,
    ref,
    achievements,
  }) => {
    const [showAchievements, setShowAchievements] = useState(false);

    const handleClick = (e) => {
      setShowAchievements(!showAchievements);
    };

    return (
      <div
        className={`work-experience-card  ${theme === "dark-mode" ? "work-experience-card-dark-mode" : "light-mode"}`}
        onClick={handleClick}
      >
        <div className="company-header">
          <div className="company-info-container">
            <a
              className="company-name"
              target="_blank"
              rel="noreferrer"
              href={companyUrl}
            >
              {companyName}
            </a>
            <p
              className={`company-role ${theme === "dark-mode" && "text-dark"}`}
            >
              {companyRole}
            </p>
          </div>
          <div className="company-location-dates">
            <div
              className={`date-range ${theme === "dark-mode" && "text-dark"}`}
            >
              <p>{startDate}</p>
              <span> - </span>
              <p>{endDate}</p>
            </div>
            <div className="company-location">{locationWorkType}</div>
          </div>
        </div>

        {/* show work achievements*/}
        <AnimatePresence>
          {showAchievements && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className={`work-achievements ${theme !== "dark-mode" && "work-achievements-light"}`}
            >
              <ul>
                {achievements.map((achievement, index) => (
                  <li key={index}>{achievement}</li>
                ))}
              </ul>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    );
  };
  const WorkExperience = () => {
    return (
      <div>
        <h2>Work Experience</h2>

        {workExpirince.map((exp, index) => (
          <WorkExperienceCard key={index} {...exp} />
        ))}
      </div>
    );
  };
  const flyRef = useRef(null);
  const flyTwoRef = useRef(null);
  let x = window.innerWidth / 2;
  let y = window.innerHeight / 2;

  const wander = useCallback(() => {
    // 90% chance of a small movement, 10% chance of a larger movement
    const distance = Math.random() < 0.1 ? 30 : 200;

    x += (Math.random() - 0.5) * distance;
    y += (Math.random() - 0.5) * distance;

    x = Math.max(0, Math.min(window.innerWidth - 20, x));
    y = Math.max(0, Math.min(window.innerHeight - 20, y));
    const reffs = [flyRef, flyTwoRef];
    for (let i = 0; i < reffs.length; i++) {
      if (reffs[i].current) {
        reffs[i].current.style.left = `${x}px`;
        reffs[i].current.style.top = `${y}px`;
      }
    }

    setTimeout(wander, 50 + Math.random() * 150);
  }, []);

  useEffect(() => {
    if (flyRef.current && theme !== "dark-mode") wander();
  }, [theme, wander]);

  const ProjectCard = ({ item }, index) => {
    const { name, url, description, state } = item;
    console.log(name);

    return (
      <>
        {" "}
        <div
          className={`work-experience-card  ${theme === "dark-mode" ? "projects-worth-noting-dark-mode" : "light-mode"}`}
          // onClick={handleClick}
        >
          <div className="project-info-container ">
            <a
              className="project-header"
              target="_blank"
              href={url}
              rel="noreferrer"
            >
              {name}
              <div className="app-state-badge">
                <p>{state}</p>
              </div>
            </a>
            <p className="project-discription">{description}</p>
          </div>
        </div>
      </>
    );
  };

  const ProjectsWorthNoting = () => {
    return (
      <div className="projects-worth-noting">
        <h2>Projects Worth Noting</h2>
        {projectsWorthNoting.map((item, index) => (
          <ProjectCard idex={index} item={item} />
        ))}
      </div>
    );
  };

  return (
    <div>
      <button onClick={toggleTheme}>
        {theme === "dark-mode" ? "Light = bugs" : "!bugs "}
      </button>
      {theme !== "dark-mode" && (
        <>
          <div ref={flyRef} className="fly">
            <div className="flymidbody"></div>
            <div className="fly-wing-left"></div>
            <div className="fly-wing-right"></div>
            <div className="flyButt"></div>
          </div>
          {/* <div ref={flyTwoRef} className="fly">
            <div className="flymidbody"></div>
            <div className="fly-wing-left"></div>
            <div className="fly-wing-right"></div>
            <div className="flyButt"></div>
          </div>*/}
        </>
      )}
      <div className="contanier">
        <TitleName />
        <Links />
        <Discription />
        <WorkExperience />
        <ProjectsWorthNoting />
      </div>
    </div>
  );
};

export default HomePage;
